// extracted by mini-css-extract-plugin
module.exports = {"image":"image__2u3Oy","image__view":"image__view__2ZXbK"};